import React from 'react';

import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';

import CarbonFreeColumnManager from './CarbonFreeColumnManager';
import CarbonFreeDataModel from './CarbonFreeDataModel';
import CarbonFreeSummaryDataModel from './CarbonFreeSummaryDataModel';
import CarbonFreeSummaryView from './CarbonFreeSummaryView';

export class CarbonFreeMain extends ScheduleMain {
  constructor(props) {
    super(props);

    this.summaryDataModel = new CarbonFreeSummaryDataModel(this.counterparty.preferenceGroupName);

    this.dataModel = new CarbonFreeDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new CarbonFreeColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  componentWillUnmount() {
    this.summaryDataModel.dispose();

    super.componentWillUnmount();
  }

  getDataGridRowClassName() {
    return 'pwx-opt-in-datagrid-row';
  }

  renderUsageSummaries() {
    return (
      <div>
        <CarbonFreeSummaryView
          dataModel={this.summaryDataModel}
          locale={this.locale}
        />
      </div>
    );
  }

  async loadGridValues() {
    var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth
    );

    this.dataModel.processFullServerUpdate(scheduleUpdateDto);

    this.commandDataModel.updateProperties({
      isEditingEnabled: this.dataModel.isEditingEnabled,
      canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences,
      currentContracts: this.dataModel.contracts,
      resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues),
      recalculateContracts: this.dataModel.contracts.filter(contract => contract.enableRecalculateValues)
    });
  }

  async updateGridValues(lastRetrievalTimeUtc) {
    var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth,
      lastRetrievalTimeUtc
    );

    this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
  }

  submitGridChanges(onSubmitFinished) {
    var dateSubmissions = this.dataModel.getCurrentModifications();
    ScheduleApi.submitChanges(
      this.counterparty.code,
      dateSubmissions,
      onSubmitFinished,
      false
    );
  }

  revertGridChanges() {
    this.dataModel.revertCurrentModifications();
  }
}
